import { ButtonV2, Modal } from '@cimplico/components';
import { COAProvider, Entity } from '../../../../types/entity';
import Chart from './Chart';

type PreviewChartModalProps = {
    onClose: () => void;
    entity: Entity;
    provider?: COAProvider | null;
};
function PreviewChart({ onClose, entity, provider = null }: PreviewChartModalProps): JSX.Element {
    const manualChart = entity.charts.find((c) => c.provider === provider);

    if (!manualChart) {
        return <></>;
    }

    return (
        <Modal isOpen onClose={onClose}>
            <div className="py-8 px-12 w-[1200px] h-[800px] flex flex-col">
                <div className="border-b mb-2 pb-4">
                    <p className=" text-gray-800 font-bold text-left text-lg"> Chart of Accounts</p>
                    <p className="text-left text-gray-600 text-sm"></p>
                </div>
                <div className="overflow-auto grow px-1">
                    <Chart entity={entity} id={manualChart.id} />
                </div>
                <div className="border-t pt-4 mt-2 flex justify-end gap-2">
                    <ButtonV2 onClick={onClose} label="Cancel" size="sm" type="hollow" />
                    <ButtonV2 onClick={onClose} label="Finish and close" size="sm" type="primary" />
                </div>
            </div>
        </Modal>
    );
}

export default PreviewChart;
